import React, { Component } from "react";
import styles from "./Toolbar.module.scss";
import { cx } from '../../../helpers/ClassNames.helper';

class Toolbar extends Component {


	handleRotate(val) {
		this.props.updateCamera(
			(camData) => {
				camData.azimuth += Math.PI / 3 * val;
				return camData;
			}
		);
	}

	handleZoom(val) {
		this.props.updateCamera(
			(camData) => {
				camData.radius *= 1 - (val / 4);
				return camData;
			}
		);
	}



	render() {
		const { camera, changeCamera } = this.props;

		return (
			<div className={styles.host}>
				<div
					className={cx(styles.button, styles.cameraBody, camera === 'start' && styles.active)}
					onClick={() => changeCamera('start')}>
					<i className="fas fa-video"></i>
				</div>
				<div
					className={cx(styles.button, styles.cameraFace, camera === 'face' && styles.active)}
					onClick={() => changeCamera('face')}>
					<i className="fas fa-video"></i>
					<i className="fas fa-user"></i>
				</div>
			</div>
		);
	}
}

export default Toolbar;
